export function formatJalaliDateFa(databaseDate) {
  const str = String(databaseDate);
  const formatted = `${str.slice(0,4)}/${str.slice(4,6)}/${str.slice(6,8)}`;
  return formatted.replace(/\d/g, d => "۰۱۲۳۴۵۶۷۸۹"[d]);
}